import { IGamePlaySounds } from './IGamePlaySounds'
import { playSound } from '../sound'
import { SOUND_KEYS } from '../../components/GamePlayComponents/constant'

export class DefaultSoundsPlayer implements IGamePlaySounds {
  playStartSoundOfGame(): void {
    playSound(SOUND_KEYS.START)
  }

  playTotalTimeSoundOfGame(): void {}

  playExtra56Score(): void {
    playSound(SOUND_KEYS.REACH_HOME)
  }

  playHalfTimeSound(): void {}

  playLastOneMinutesSound(): void {}

  playSkipSound(skipCount: number): void {
    playSound(SOUND_KEYS.SKIP)
  }

  playTokenToHomeSound(): void {}

  playZyadaScoreSound(): void {}

  playDusrePlayerKaTokenKaatSkteHai(): void {}

  playTokenKoSafeSpotPrLeJaaSkteHai(): void {}

  playTokenKoGharLeJaaSkteHai(): void {}
}
